

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const syncAdminPermissions = async (adminId, permissions, leadFieldAccess = {}) => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('[syncAdminPermissions] Ошибка: Токен авторизации не найден.');
    // throw new Error('Токен авторизации не найден.');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/admin-accounts/${adminId}/permissions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        permissions: permissions,
        lead_field_access: leadFieldAccess,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error(`[syncAdminPermissions] Ошибка синхронизации прав для администратора ${adminId}:`, errorData);
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[syncAdminPermissions] Ошибка сети или другая ошибка при синхронизации прав администратора:', error);
    throw error;
  }
};
